import { ReactElement } from 'react';
import { Typography, Button, Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import AdminPanelSettingsRoundedIcon from '@mui/icons-material/AdminPanelSettingsRounded';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

import { useRoutes, useApiGetter, MembershipService } from '@localstack/services';

import { AdminPermission } from '@localstack/types';

import { AdminLayout } from '~/layouts';
import { useAuthProvider } from '~/hooks/useAuthProvider';
import { AppRoute } from '~/config';

const StyledNavigationButton = styled(Button)(({ theme }) => ({
  color: theme.palette.text.secondary,
  textTransform: 'none',
  border: '1px solid',
  borderColor: theme.palette.divider,
  '&:hover': {
    backgroundColor: 'rgba(0, 0, 0, 0.04)',
  },
}));

export const Dashboard = (): ReactElement => {
  const { userInfo } = useAuthProvider();
  const { goto } = useRoutes();
  const { can } = useAuthProvider();

  const { data: primaryMembership } = useApiGetter(MembershipService, 'getPrimaryMembership', []);

  return (
    <AdminLayout>
      <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" minHeight="60vh">
        <AdminPanelSettingsRoundedIcon sx={{ fontSize: 64, color: 'text.secondary', mb: 2 }} />

        <Typography variant="h3" align="center" gutterBottom>
          Welcome, {userInfo?.user?.firstname}!
        </Typography>

        <Box display="flex" gap={2} mt={3}>
          <StyledNavigationButton
            variant="text"
            endIcon={<ArrowForwardIcon />}
            onClick={() => goto(AppRoute.ADMIN_ACCOUNT, { id: userInfo?.user.id })}
            disabled={!userInfo || !can(AdminPermission.USERS_READ)}
          >
            Go to my account
          </StyledNavigationButton>
          <StyledNavigationButton
            variant="text"
            endIcon={<ArrowForwardIcon />}
            onClick={() => goto(AppRoute.ADMIN_ORGANIZATION, { id: primaryMembership?.org_id })}
            disabled={!userInfo || !can(AdminPermission.WORKSPACES_READ)}
          >
            Go to my organization
          </StyledNavigationButton>
        </Box>
      </Box>
    </AdminLayout>
  );
};
